export const ADD_CONFIG = "ADD_CONFIG"

export function addConfig(payload) {

    return {
        type: ADD_CONFIG,
        payload: payload
    }
}